import CrossIcon from './cross-icon'

export default CrossIcon
